<section class="help help__container">
  <header class="help__header">
    <p class="help__title">
      <i class="flex items-center icon icon-help-circle text-xl"> </i>
      <span>{{ "labels.HELP_AND_DOCUMENTATION" | translate }}</span>
    </p>

    <i
      role="button"
      aria-label="Close"
      class="help__close-button pi pi-times"
      (click)="close.emit()"
    ></i>
  </header>
  <p-divider class="!m-0" />

  <div class="help__content !h-100 !overflow-y-auto">
    <ng-container *ngIf="!helper(); else helpItemFields">
      @if (helpAndDocumentationService.content()?.length > 0) {
        <div
          *ngFor="
            let helpItem of helpAndDocumentationService.content();
            trackBy: trackByFn
          "
          class="flex flex-col px-2"
          [class.cursor-pointer]="helpItem?.children?.length > 0"
          (click)="helpItem?.children?.length > 0 ? setHelper(helpItem) : null"
        >
          <div class="flex flex-col my-2">
            <div class="flex flex-row justify-between">
              <div>
                <h6 *ngIf="helpItem.title" class="font-bold !m-0">
                  {{ helpItem.title }}
                </h6>
              </div>
              <div *ngIf="helpItem?.children?.length > 0">
                <i class="pi pi-arrow-right rtl-flip"></i>
              </div>
            </div>
            <div class="text-gray-500 pt-1">
              <app-markdown-viewer [content]="helpItem.content" />
            </div>
          </div>
          <p-divider styleClass="!my-1"></p-divider>
        </div>
      } @else {
        <div class="flex flex-col px-2">
          <div class="flex flex-col my-2">
            <div class="flex flex-row justify-between">
              <div>
                <h6 class="font-bold !m-0">
                  {{ "labels.NO_HELP_AND_DOCUMENTATION" | translate }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-container>
    <ng-template #helpItemFields>
      <div class="flex flex-col">
        <div class="flex flex-col px-2 my-2">
          <div class="flex flex-col gap-2">
            <div
              class="flex items-center gap-2 !text-[#535862] cursor-pointer w-fit"
              (click)="setHelper(null)"
              (keyup.enter)="setHelper(null)"
              tabIndex="0"
            >
              <i class="pi pi-arrow-left !font-semibold rtl-flip"></i>
              <span class="font-semibold">
                {{ "base.actions.back" | translate }}
              </span>
            </div>
            <div class="flex flex-col pt-1">
              <h6 *ngIf="helper()?.title" class="font-bold !m-0">
                {{ helper()?.title }}
              </h6>
              <div class="text-gray-500 py-1">
                <app-markdown-viewer [content]="helper()?.content" />
              </div>
            </div>
          </div>

          <p-divider styleClass="!my-1"></p-divider>
        </div>

        <span class="uppercase text-[#717680] font-bold text-xs mt-1 ms-2">{{
          "label.FIELDS" | translate
        }}</span>
        <div
          *ngFor="let helpItem of helper()?.children; trackBy: trackByFn"
          class="flex flex-col px-2"
        >
          <div class="flex my-2">
            <div class="flex flex-col w-100">
              <h6 *ngIf="helpItem.title" class="font-bold !m-0 capitalize">
                {{ helpItem.title }}
              </h6>
              <div class="text-gray-500 pt-1 pb-2">
                <app-markdown-viewer [content]="helpItem.content" />
              </div>
              @if (helpItem.children?.length > 0) {
                <div
                  class="p-2 border border-[var(--dividerColor)] border-solid rounded-lg"
                >
                  <div
                    *ngFor="
                      let subHelpItem of helpItem.children;
                      trackBy: trackByFn;
                      let last = last
                    "
                    class="flex flex-col mt-1"
                  >
                    <h6
                      *ngIf="subHelpItem.title"
                      class="font-bold !m-0 capitalize"
                    >
                      {{ subHelpItem.title }}
                    </h6>
                    <div class="text-gray-500 pt-1">
                      <app-markdown-viewer [content]="subHelpItem.content" />
                    </div>
                    <p-divider *ngIf="!last" styleClass="!my-1"></p-divider>
                  </div>
                </div>
              }
            </div>
          </div>
          <p-divider styleClass="!my-1"></p-divider>
        </div>
      </div>
    </ng-template>
  </div>
</section>
